import React from 'react';
import { Box } from '@mui/material';

import styles from './instaTaskMain.styles';

const InstaTaskMain = ({ tabs, content }) => {
  return (
    <Box sx={styles.instaTaskMainWrapper}>
      {tabs}
      <Box sx={styles.instaTaskContentWrapper}>{content}</Box>
    </Box>
  );
};

export default InstaTaskMain;
